import { DefaultContext } from 'xstate'

import { logAndCaptureMessage } from '../../../../utils/errorTools'
import { isStateMachineClaim, userClaimIds } from '../../../../utils/userClaims'
import { AuthStateWithAccessToken } from '../../../auth/state'
import { isValidRewardsState } from '../utils'
import { RewardsOnboardingStateValue } from './machine-rewards-onboarding'

export interface RewardsOnboardingClaim {
  state: RewardsOnboardingStateValue
  context: DefaultContext
}

export const rewardsOnboardingClaim = (
  authState: AuthStateWithAccessToken,
): RewardsOnboardingClaim | undefined => {
  const claimValue =
    authState.isAuthenticated && authState.user
      ? (authState.user[userClaimIds.rewardsOnboarding] as unknown)
      : undefined
  if (!isStateMachineClaim(claimValue) || !claimValue.state) {
    return undefined
  }
  const state = claimValue.state.trim()
  const context = claimValue.context ?? {}
  if (!isValidRewardsState(state)) {
    logAndCaptureMessage(`Invalid rewards onboarding state "${state}" in user claim`, {
      level: 'warning',
    })
    return undefined
  }
  return {
    state,
    context,
  }
}
